<h5 class="ds-body ds-color--black mt-4 mt-lg-0">{{'leadForm.sections.personalDetails' | cxTranslate}}</h5>
<ng-container *ngIf="submitStatus">
  <div data-cy="input">
    <ds-input #email
              (focusEvent)="blurHandler($event, email.value)"
              [(ngModel)]="leadFormModel.addressesMap.LTCP.email"
              [disabled]="disableEmailField"
              [label]="(sapEmployeeSubject.value ? 'leadForm.fields.emailEmployee' : 'leadForm.fields.email')
                      | cxTranslate"
              [placeholder]="(sapEmployeeSubject.value ? 'leadForm.fields.emailEmployee' : 'leadForm.fields.email')
                      | cxTranslate"
              [showErrorMessages]="submitStatus.submitted"
              class="mt-4"
              dsEmail
              fieldName="email"
              maxlength="255"
              name="email"
              required
              type="email">
    </ds-input>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(email, 'required')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.invalidEmail' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(email, 'email') && !hasValidationFailed(email, 'required')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(email, 'maxlength') && !hasValidationFailed(email, 'email')">
    </ds-input-error>
    <dcp-lead-form-user-login *ngIf="(authService.isUserLoggedIn() | async) === false"
                              [transactionType]="transactionType"
                              [transactionListCta]="transactionListCta"
                              [userType]="userType"
                              class="mt-4">
    </dcp-lead-form-user-login>
  </div>
  <div data-cy="input">
    <ds-input #firstName
              [(ngModel)]="leadFormModel.addressesMap.LTCP.firstName"
              [disabled]="userType.isEmployeeLogin"
              [label]="(sapEmployeeSubject.value ? 'leadForm.fields.firstNameEmployee' : 'leadForm.fields.firstName')
                      | cxTranslate"
              [placeholder]="(sapEmployeeSubject.value ? 'leadForm.fields.firstNameEmployee' : 'leadForm.fields.firstName')
                      | cxTranslate"
              [showErrorMessages]="submitStatus.submitted"
              class="mt-4"
              dcpWhitespaceOnly
              fieldName="firstName"
              id="firstName"
              maxlength="255"
              name="firstName"
              required
              type="text">
    </ds-input>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(firstName, 'required') || hasValidationFailed(firstName, 'whitespaceOnly')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(firstName, 'maxlength')">
    </ds-input-error>
  </div>
  <div data-cy="input">
    <ds-input #lastName
              [(ngModel)]="leadFormModel.addressesMap.LTCP.lastName"
              [disabled]="userType.isEmployeeLogin"
              [label]="(sapEmployeeSubject.value ? 'leadForm.fields.lastNameEmployee' : 'leadForm.fields.lastName')
                      | cxTranslate"
              [placeholder]="(sapEmployeeSubject.value ? 'leadForm.fields.lastNameEmployee' : 'leadForm.fields.lastName')
                      | cxTranslate"
              [showErrorMessages]="submitStatus.submitted"
              class="mt-4"
              dcpWhitespaceOnly
              fieldName="lastName"
              maxlength="255"
              name="lastName"
              required
              type="text">
    </ds-input>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(lastName, 'required') || hasValidationFailed(lastName, 'whitespaceOnly')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(lastName, 'maxlength')">
    </ds-input-error>
  </div>
  <div data-cy="input">
    <ds-input [(ngModel)]="leadFormModel.addressesMap.LTCP.phone"
              [disabled]="userType.isEmployeeLogin"
              [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
              [label]="'leadForm.fields.phone.phoneNumber' | cxTranslate"
              [placeholder]="'leadForm.fields.phone.phoneNumber' | cxTranslate"
              [showErrorMessages]="submitStatus.submitted"
              [tooltipContent]="'leadForm.fields.phone.phoneTooltip' | cxTranslate"
              class="mt-4"
              fieldName="phoneNumber"
              maxlength="32"
              name="phoneNumber"
              type="tel">
    </ds-input>
  </div>
</ng-container>
